module.exports = __webpack_public_path__ + "static/img/clothing_02.4ad6b4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/clothing/thumbnail/clothing_02.png
// module id = VND7
// module chunks = 0